export function getTTPCookie() {
  const match = document.cookie.match(/_ttp=([^;]+)/);
  return match ? match[1] : null;
}

export function getTTClickIDCookie(){
  const match = document.cookie.match(/ttclid=([^;]+)/);
  return match ? match[1] : null;
}
